import _ from 'lodash';
import numeral from 'numeral';

import DataTable from '../../core/charts/Datatable';
import dialog from '../../core/dialog';
import infoBoard from '../../core/infoboard';
import worldMap from '../../core/map';
import dataBoard from '../../core/databoard';
import templates from '../../core/templates';
import translate from '../../core/tools/translate';
import environment from '../../environment';
import { customScrollbar } from '../../shared';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import api from '../../api';
import Workspace from '../../workspaces';
import { ControlType, Item } from '../../workspaces/item';
const LayerInfo = (name) => require('../../info').get(name);
const LayerControls = (name) => require('../../controls').get(name);
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

class ShapesInfo {
    constructor(options) {
        this.check = this.check.bind(this);
        this.options = _.assign({}, this.options, options);

        this._status = false;
        this._mainContainer = null;
        this._selectedAreaId = undefined;
    }

    init() {
    }

    getLayer() {
        this.options.layer = LayerControls(this.options.name).getLayer();
        return this.options.layer;
    }

    _getTemplate(type, values) {
        if (_.isArray(type)) {
            return templates(`${type[0]}-${type[1]}`, values);
        } else {
            return templates(`shared-${type}`, values);
        }
    }

    _getContainer() {
        return infoBoard.createContainer({
            id: this.options.name,
            name: this.options.label,
            actions: this._hasSummary()
        });
    }

    setCacheEntries(item, add = true) {
        let cacheEntry = [];
        const cache = environment.get('DNC.ENTRIES');
        if (!_.isUndefined(cache)) _.map(cache, f => {
            cacheEntry.push(f);
        });

        if (add) cacheEntry.push(item);
        else _.remove(cacheEntry, g => _.isEqual(g, item));

        environment.set('DNC.ENTRIES', cacheEntry);
    }

    _content(container, feature, index, autoHighlight = true) {
        const options = {
            check: this.check,
            container,
            feature,
            index,
            name: this.options.name,
            originalName: this.options.name,
            controls: {
                actions: this._hasActions(),
                //summary: this._hasSummary(),
                selection: this._hasSummary()
            }
        };

        if (feature.properties.disabled) {
            return;
        }

        const item = infoBoard.createItem(options);
        const layer = this.getEntry().get(String(feature.properties.Id)) || this.getLayer().getLayer(feature.properties.Id);

        if (!item) return;

        if (item.btn.summary) {
            item.btn.summary.on('click', (e) => {
                this._showSummary(feature);
                Workspace.addAction(new Item(`#${item.btn.summary.prop('id')}`, '', ControlType.InputButton));
            });
        }

        if (item.btn.selection) {
            item.btn.selection.on('ifChecked', (e) => {
                this.add(item.feature);
                this.setCacheEntries(item.feature, true);
                Workspace.addAction(new Item(`#${e.target.id}`, true, ControlType.ICheckBox));
            });
            item.btn.selection.on('ifUnchecked', (e) => {
                this.setCacheEntries(item.feature, false);
                this.remove(item.feature);
                Workspace.addAction(new Item(`#${e.target.id}`, false, ControlType.ICheckBox));
            });
        }

        if (autoHighlight) {
            if (this.check(feature.properties.Id)) {
                this.highlight(feature, {
                    layer,
                    fixed: true,
                    force: true
                });
            }
        }

        return item;
    }

    _showCustomersPanel() {
        const date = LayerControls(this.options.name).getDate();
        const optionsRequest = {
            Ids: _.map(this.getSelectedEntries(), e => e.Id),
            anoMesFim: date.end.format('YYYYMM'),
            anoMesInicio: date.start.format('YYYYMM'),
            idTema: 24,
            idTipo: this.getType(),
        };

        api.themes.get.areas.customers(optionsRequest)
            .then((res) => {
                const dataSource = {
                    perPercentage: _(res)
                        .groupBy('nameStore')
                        .map((val, key) => {
                            return {
                                Nome: key,
                                Total: val.length / res.length
                            };
                        })
                        .orderBy('Total', 'desc')
                        .value(),

                    perTotal: _(res)
                        .groupBy('nameStore')
                        .map((val, key) => {
                            return {
                                Nome: key,
                                Total: val.length
                            };
                        })
                        .orderBy('Total', 'desc')
                        .value(),

                    summary: _(res)
                        .groupBy('nameLocale')
                        .map((loc, key) => {
                            return _(loc)
                                .groupBy('nameStore')
                                .map((store, key) => {
                                    return {
                                        nameLocale: loc[0].nameLocale,
                                        idStoreClient: store[0].idStoreClient,
                                        nameStore: key,
                                        nameEconomicGroup: store[0].nameEconomicGroup,
                                        total: store.length,
                                        percentage: store.length / loc.length
                                    };
                                })
                                .value();
                        })
                        .flatten()
                        .orderBy(['nameLocale', 'total'], ['asc', 'desc'])
                        .value()
                };

                const chartPie = new DataTable(dataSource.perPercentage, {
                    row: translate("Common.Name"),
                    column: [translate("Common.Total")]
                });

                const chartColumn = new DataTable(dataSource.perTotal, {
                    row: translate("Common.Name"),
                    column: [translate("Common.Total")]
                });

                const panel = {
                    title: {
                        table: `${translate(`Common.${this.options.name}`)} - Sumário - ${date.start.format('MM/YYYY')} a ${date.end.format('MM/YYYY')}`,
                        chartPie: `TOP 10 - ${translate("Common.Dealer")} (%)`,
                        chartColumn: `TOP 10 - ${translate("Common.Dealer")}`
                    },
                    dash: true,
                    colors: [
                        null,
                        _.map(_.range(0, dataSource.perTotal.length), () => "#3498db")
                    ],
                    data: [dataSource.summary, chartPie, chartColumn],
                    convertTable: false,
                    format: ["{0:n0}", "{0:p2}", "{0:n0}"],
                    columns: [
                        {
                            field: "nameLocale",
                            title: "Area"
                        },
                        {
                            field: "idStoreClient",
                            title: 'Dealer Number'
                        },
                        {
                            field: "nameStore",
                            title: translate("Common.Name")
                        },
                        {
                            field: "nameEconomicGroup",
                            title: translate("Common.Group")
                        },
                        {
                            field: "total",
                            title: translate("Common.Total"),
                            width: 100,
                            template: dataSource => numeral(dataSource.total).format("0,0")
                        },
                        {
                            field: "percentage",
                            title: `${translate("Common.Total")} (%)`,
                            width: 100,
                            template: dataSource =>
                                numeral(dataSource.percentage).format("0,0[.]00%")
                        }
                    ]
                };

                dataBoard.show(panel);
            })
            .catch(console.error);
    }

    _showSummary(feature) {
        const opt = {
            type: this.getType,
            context: this.options.context,
            visible: true,
            grouping: _.some(environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES'), v => v.name === LayerControls(this.options.name).getTypeText())
        };

        if (feature) {
            opt.id = feature.properties.Id;
            opt.title = feature.properties['Nome'];
        } else {
            opt.id = _.map(this.getSelectedEntries(), e => e.Id);
            opt.locations = {
                title: translate('Common.Locations'),
                chart: new DataTable(_.map(this.getSelectedEntries(), e => ({
                    [translate('Common.Name')]: e.Nome,
                    [translate('Common.Complement')]: (e.Complemento || '').replace(new RegExp(`${e.Nome},? ?`), '').toASCII(),
                    [translate('Common.Type')]: e.Tipo
                })), {
                    column: [translate('Common.Complement'), translate('Common.Type')],
                    row: translate('Common.Name')
                })
            };
            opt.title = `
                <a id="summary-title-popup" tabindex="0" href="#" class="btn btn-link" style="padding: 2px;" role="button" data-trigger="hover" data-toggle="popover" data-container="body" data-placement="bottom" data-content="${_.map(this.getSelectedEntries(), e => e.Nome).join(' - ')}">
                    ${_.size(this.getSelectedEntries())}
                </a>
                ${translate('Common.SelectedLocation')}
            `;
            opt.name = this.getSelectedEntries().map(x => x.Nome).join(", ");
            opt.label = translate('Common.SelectedLocation');
        }

        LayerInfo('SummaryAfterSales').create(opt);
    }

    _selectOneAreaMessage(name) {
        notify(NOTIFY_TYPE.LOG, translate('Validation.LocationRequired'));
        setTimeout(() => {
            LayerControls(this.options.name).getControls().checkbox[name].input.iCheck('uncheck');
        }, 100);
    }

    _filterByLocation(state) {
        if (state && this.getEntry().size === 0) {
            return this._selectOneAreaMessage('filterLocation');
        }

        const values = [];
        this.getEntry().forEach((status, id) => values.push(id));

        const { filter = {} } = this.options.layer;
        if (!filter.properties) {
            filter.properties = {};
        }

        if (state && this.getEntry().size > 0) {
            filter.properties.Id = values;
        } else {
            if (filter.properties.Id) {
                delete filter.properties.Id;
            }
        }

        this.getLayer().setOptions({ filter });
        const controls = LayerControls(this.options.name);
        if (controls.check()) {
            this.getLayer().reload();
        }
    }

    _filterByAreas(state) {
        if (state && this.getEntry().size === 0) {
            return this._selectOneAreaMessage('filterLocation');
        }

        const layerList = ['MarkedAreaAfterSales', 'SelectedAreasAfterSales'].filter(l => l !== this.options.name);
        const features = [];
        this.getEntryAsFeature().forEach((feature) => features.push(feature));

        if (state && this.getEntry().size) {
            this._applyLayerOverlap(layerList, 'shape', features);
        } else {
            this._applyLayerOverlap(layerList, 'shape', null);
        }
    }

    _filterByPoints(state) {
        if (state && this.getEntry().size === 0) {
            return this._selectOneAreaMessage('filterPoints');
        }

        const layerList = [
            'NetworkAfterSales',
            'CompetitorsAfterSales',
            'ClientSalesAfterSales',
            'CustomersAfterSales',
            'MulticriteriaAfterSales',
            'DealershipAfterSales',
            'PGTS',
            'WorkshopPart'];
        const features = [];
        this.getEntryAsFeature().forEach((feature) => features.push(feature));

        if (state && this.getEntry().size) {
            this._applyLayerFilter(layerList, 'shape', features);
        } else {
            this._applyLayerFilter(layerList, 'shape', null);
        }
    }

    _applyLayerFilter(layers, type, features) {
        _.forEach(layers, (name) => {
            try {
                const currentLayer = LayerControls(name).getLayer();
                if (currentLayer && currentLayer.options) {
                    const filter = currentLayer.options.filter || {};
                    filter[type] = features;
                    currentLayer.setOptions({ filter });
                    if (worldMap.hasLayer(currentLayer.layer)) {
                        currentLayer.reload();
                    }
                }
            } catch (err) {
                console.log(err);
            }
        });
    }

    _applyLayerOverlap(layers, type, features) {
        _.forEach(layers, (name) => {
            try {
                const currentLayer = LayerControls(name).getLayer();
                if (currentLayer && currentLayer.options) {
                    const remote = currentLayer.options.remote || {};
                    remote.params.overlap = features ? features.map(f => f.properties.Id).join(',') : undefined;
                    currentLayer.setOptions({ remote });
                    if (worldMap.hasLayer(currentLayer.layer)) {
                        currentLayer.redraw();
                    }
                }
            } catch (err) {
                console.log(err);
            }
        });
    }

    create(features) {
        // console.time('Shapes -> create');

        this._mainContainer = this._getContainer();
        // do not render if there is not data
        const controls = LayerControls(this.options.name);
        if (infoBoard.dataUnavailable({
            features,
            container: this._mainContainer,
            isEnabled: controls.check()
        })) {
            return this.show(this._mainContainer);
        }

        this._status = !!features;

        const template = $(templates('infoboard-content', {
            id: `${this.options.name}-collapse`,
            actions: this._hasSummary()
        }));
        const content = template.find('.panel-group');

        let index = 0;

        features = [
            ...features.filter(f => !this.check(f.properties.Id)),
            ...this.getEntryAsFeature()
        ].sort((a, b) => a.properties.Nome > b.properties.Nome ? 1 : -1);

        _(features)
            .forEach(f => {
                const item = this._content(this._mainContainer, f, index++);
                if (item) {
                    content.append(item.layout);
                }
            });

        // give the DOM a break
        $(this._mainContainer).detach().append(template).appendTo('#infoboard-content');

        if (this._hasSummary()) {
            infoBoard.enableSelection(this._mainContainer, this.options.name);
        }

        customScrollbar(content);
        // console.timeEnd('Shapes -> create');
    }

    // END: create: (features) ->
    show(container) {

        // console.time('Shapes -> show');

        // hide actions menu
        $(container).find('.panel-context').hide();

        if (this._status) {
            const disabled = this.getEntry().size === 0 ? 'disabled' : '';
            const $template = $(this._getTemplate('action-bar', {
                disabled,
                id: `${this.options.name}-submit`,
                reset: true
            }));
            $(container).append($template);

            $template.find('.action-submit').on('click', () => {
                Workspace.addAction(new Item(`#${$template.prop('id')} .action-submit`, '', ControlType.InputButton));
                this._handleClickAction();
            });

            $template.find('.action-cancel').on('click', () => {
                Workspace.addAction(new Item(`#${$template.prop('id')} a[data-target="select_none"]`, '', ControlType.InputButton));
                return $('a[data-target="select_none"]').trigger('click');
            });
        }
    }

    _handleClickAction = () => {
        this._showSummary.bind(this)();
    };

    highlight(feature, options) {
        this.getLayer().highlight(feature, options);
    }

    unhighlight(feature, options) {
        this.getLayer().unhighlight(feature, options);
    }

    blank() {
        _(this.getLayer().getCurrentFeatures())
            .filter(f => f ? !this.check(f.properties.Id) : false)
            .forEach(f => this.getLayer().unhighlight(f));
    }

    reset() {
        this.getEntry().clear();
        this._selectedAreaId = undefined;

        const controls = LayerControls(this.options.name);

        if (controls.check()) {
            this.unhighlight(true);
            controls.reload();
        }
    }

    add(feature, layer) {
        if (!feature) return;

        infoBoard.open();

        this._selectedAreaId = String(feature.properties.Id);
        this.setEntry(this._selectedAreaId, true);

        $(`#${this.options.name}-tab-link`).click();
        if (this.getEntry().size > 0) {
            $(`#${this.options.name}-submit`).find('.action-submit').attr('disabled', false);
        }

        this.highlight(feature, {
            fixed: true,
            layer
        });

        if (this._filterAreas) {
            this._filterByAreas(true);
        }

        if (this._filterLocation) {
            this._filterByLocation(true);
        }

        if (this._filterPoints) {
            this._filterByPoints(true);
        }
    }

    remove(feature, layer) {
        const featureId = String(feature.properties.Id);

        if (this.getEntry().size < 1) {
            $(`#${this.options.name}-submit`).find('.action-submit').attr('disabled', true);
        }

        this.unhighlight(feature, {
            fixed: false,
            layer
        });

        this.getEntry().delete(featureId);

        if (this._filterAreas) {
            this._filterByAreas(true);
        }

        if (this._filterLocation) {
            this._filterByLocation(true);
        }

        if (this._filterPoints) {
            this._filterByPoints(true);
        }
    }

    getLastSelectedAreaId() {
        return this._selectedAreaId;
    }

    getStatus() {
        return this._status;
    }

    set(value) {
        this._status = value;
    }

    check(id) {
        return this.getEntry().has(String(id));
    }

    setEntry(id, value) {
        const entry = this.getEntry();
        entry.set(String(id), value);
    }

    getEntry() {
        return this.getLayer().state.highlight;
    }

    getEntryAsFeature() {
        const entries = [];
        const cacheEntrie = environment.get('DNC.ENTRIES');
        if (!_.isUndefined(cacheEntrie)) {
            _.map(cacheEntrie, f => {
                this.setEntry(f.properties.Id, true);
                this.highlight(f, {
                    fixed: true,
                    undefined
                });
            });

        }
        this.getLayer().state.highlight.forEach((status, id) => entries.push(id));

        const features = [];
        this.getLayer().state.features.forEach((feature, id) => {
            if (_.some(entries, (e) => String(e) === String(id))) {
                features.push(feature);
            }
        });

        return features;
    }

    getSelectedEntries() {
        const out = [];
        this.getEntryAsFeature().forEach((feature) => {
            out.push(feature.properties);
        });

        const layerTypeId = LayerControls(this.options.name).getTypeValue();
        return _.filter(out, p => p.IdTipoLocalidade === layerTypeId);
    }

    values(visible = false) {
        const output = {
            id: [],
            type: Number(LayerControls(this.options.name).get().scheme())
        };

        if (visible) {
            this.getLayer().getCurrentFeatures().forEach(feature => output.id.push(feature.properties.Id));
        } else {
            this.getEntry().forEach((status, id) => output.id.push(id));
        }

        return output;
    }

    setFilterByPoints(state) {
        this._filterPoints = state;
        this._filterByPoints(state);
    }

    setFilterByLocation(state) {
        this._filterLocation = state;
        this._filterByLocation(state);
    }

    setFilterByAreas(state) {
        this._filterAreas = state;
        this._filterByAreas(state);
    }
}

export default ShapesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/ShapesAfterSalesInfo.js